<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="contacts" /> Vehicle type
        </span>
        <a-input
          v-model="filter.query"
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add
        </a-button>
      </div>
      <a-table
        class="top-table"
        :columns="columnsAllCustomer"
        :data-source="vehicletypes"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <a
          slot="titleType"
          slot-scope="text, record"
          @click="collapseVisibleDetail(record.id)"
        >
          {{ text }}
        </a>
        <a slot="no" slot-scope="text, record, index">
          {{ index + 1 }}
        </a>

        <span slot="author" slot-scope="text">
          {{ text.author && (text.author.fullname || text.author.username) }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="price" slot-scope="text">
          {{ text | currency }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
      </a-table>
    </a-card>

    <a-drawer
      v-if="visibleEdit"
      title="Edit"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditVehicleType
        :idVehicleType="idVehicleType"
        :close="() => (visibleEdit = false)"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
      />
    </a-drawer>

    <a-drawer
      v-if="visibleAdd"
      title="Add"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddVehicleType
        :close="() => (visibleAdd = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
  </div>
</template>
<script>
import { columnsAllCustomer } from "./constant/column";
import AddVehicleType from "./components/addVehicleType";
import EditVehicleType from "./components/editVehicleType";
import query from "./constant/query";
import debouce from "lodash/debounce";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

export default {
  components: { AddVehicleType, EditVehicleType },
  data() {
    this.onFilter = debouce(this.onFilter, 500);
    return {
      keySearch: "",
      visibleEdit: false,
      isPagination: true,
      visibleAdd: false,
      columnsAllCustomer,
      loadingList: true,
      vehicletypes: [],
      idVehicleType: "",
      limit,
      currentPage: startPage,
      filter: {},
      totalPage: startPage,
    };
  },
  methods: {
    onGetAllCustomer(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListVehicleType,
          fetchPolicy: "no-cache",
          variables: {
            limit: this.limit,
            page: this.currentPage,
            query: this.filter.query,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (flag === "PAGINATION") {
            if (
              data.getListVehicleType?.length >= 0 &&
              this.vehicletypes?.length >= 0
            ) {
              this.vehicletypes = this.vehicletypes.concat([
                ...data.getListVehicleType,
              ]);
            } else {
              this.vehicletypes = [...data.getListVehicleType];
            }
          } else {
            if (data?.getListVehicleType?.length >= 0) {
              this.vehicletypes = [...data.getListVehicleType];
            }
          }

          // check is pagniation
          if (data.getListVehicleType.length < limit) {
            this.isPagination = false;
          } else {
            this.isPagination = true;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get info error!",
          });
          console.error("Lấy danh sách khách hàng không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idVehicleType = id;
        this.visibleDetail = true;
      } else {
        this.idVehicleType = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idVehicleType = id;
        this.visibleEdit = true;
      } else {
        this.idVehicleType = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.totalPage = startPage;
      this.currentPage = startPage;
      this.onGetAllCustomer("FILTER");
    },
    refreshAfterUpdated(item) {
      this.vehicletypes = updateForUpdated(this.vehicletypes, item);
    },
    refreshAfterDeleted(item) {
      this.vehicletypes = updateForDeleted(this.vehicletypes, item);
    },
    refreshAfterCreated(item) {
      this.vehicletypes = updateForCreated({ list: this.vehicletypes, item });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllCustomer("PAGINATION");
      }
    },
  },
  created() {
    this.onGetAllCustomer();
  },
};
</script>
<style lang="css" scoped></style>
